export const OVERLAY_Z_INDEX = {
  drawer: 1200,
  mutation: 1300,
  confirmation: 1400,
} as const
